import { useSite } from "@/context/SiteContext";
import { FadeUp } from "@/components/Reveal";

export default function Stats() {
  const { settings } = useSite();
  return (
    <section className="py-14 lg:py-20" data-testid="stats-section">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-2 gap-px border border-[#1A1A1A] bg-[#1A1A1A] lg:grid-cols-4">
          {settings.stats.map((s, i) => (
            <FadeUp key={s.id} delay={i * 0.08} className="group relative bg-[#080808] p-8 lg:p-12">
              <div className="absolute left-8 top-0 h-px w-10 bg-gold/60 transition-all duration-500 group-hover:w-16 lg:left-12" />
              <div
                className="pt-4 font-serif text-4xl sm:text-5xl lg:text-6xl text-[#F5F3EE]"
                data-testid={`stat-number-${s.id}`}
              >
                {s.number}
              </div>
              <div className="mt-3 text-[10px] sm:text-[11px] font-semibold uppercase tracking-[0.28em] text-gold/90">
                {s.label}
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
